import React from "react";
import { injectStore } from "src/common/api/apiClient";
import { store } from "./app-redux/store";
import { IdleTimeOut } from "./common/api/idleTimeout";
import { WithNotifications } from "./notifications/WithNotifications";
import { AppRouting } from "./routes/AppRouting";
import { CustomMuiTheme } from "./theme/CustomMuiTheme";
import { LicenseInfo } from "@mui/x-license-pro";
import NotificationConnection from "./components/NotificationDrawer/connection";

LicenseInfo.setLicenseKey(
  "283f762e6e6ae4e811ae6939a98a0e96Tz01NjI3MyxFPTE3MDI4MzAwODAxNzAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
);

function App() {
  injectStore(store); // to access store outside React FunctionComponent
  IdleTimeOut();
  return (
    <CustomMuiTheme>
      <WithNotifications>
        <NotificationConnection />
        <AppRouting />
      </WithNotifications>
    </CustomMuiTheme>
  );
}

export default App;
